import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import * as SearchFilters from 'ha/types/SearchFilters';
import { CanonicalFurniture } from 'ha/constants/Filters';

import FilterSwitchGroup from './FilterSwitchGroup';

interface Props {
  furniture: SearchFilters.FurnitureFilterValue;
  className?: string;
  onChange: (value: SearchFilters.FurnitureFilterValue) => void;
}

interface FurnitureOption {
  value: SearchFilters.FurnitureValue;
  label: string;
  'data-test-locator'?: string;
}

export const FurnitureFilter: React.SFC<Props & IntlProps> = ({
  furniture,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Furniture')}</Typography>

    <FilterSwitchGroup
      value={furniture as string}
      onChange={(val: SearchFilters.FurnitureFilterValue) => onChange(val)}
      options={
        [
          {
            value: CanonicalFurniture.Furnished,
            label: T('Furnished'),
            'data-test-locator': 'Filter Furnished',
          },
          {
            value: CanonicalFurniture.Unfurnished,
            label: T('Unfurnished'),
            'data-test-locator': 'Filter Unfurnished',
          },
        ] as FurnitureOption[]
      }
    />
  </React.Fragment>
);

export default withIntl(FurnitureFilter);
